import "../../../src/style/visualsearchdemo.scss";

function EnhancedSearchAccuracy(){
    return (
        <div className="columns highlight-info">
            <div className="column  col-lg-12 col-6">
                <div className="content-wrap">
                    <div className="mb-1 title">Enhanced Search Accuracy</div>
                    <div className="divider"></div>
                    <div className="feature-description desc col-xl-12 col-12">
                        Search through Images but not only that, your product labels do not need all attributes to be mentioned in the description for relevant search results. We “see” those characteristics from the image and attach them to the individual products to make them searchable.
                    </div>
                </div>
            </div>
            <div className="column col-lg-12 col-6 last-lg">
                <div className="content-wrap image-block">
                    <img className="vs-img" src="./images/enhancedSearchAccuracy.png" alt="Enhanced Search Accuracy"></img>
                </div>
            </div>
        </div>
    )
}

export default EnhancedSearchAccuracy;